import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const Tooltip = ({ children, text }) => {
  const triggerRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });

  useLayoutEffect(() => {
    if (visible && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setCoords({
        top: rect.top - 8,
        left: rect.left + rect.width / 2,
      });
    }
  }, [visible]);

  return (
    <div
      ref={triggerRef}
      className="inline-flex"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && typeof document !== 'undefined' && createPortal(
        <div
          className="fixed -translate-x-1/2 -translate-y-full bg-gray-800 text-white text-xs rounded py-1 px-2 z-50 pointer-events-none"
          style={{ top: coords.top, left: coords.left }}
        >
          {text}
        </div>,
        document.body
      )}
    </div>
  );
};

export default Tooltip;
